import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	UpdatePaymentVerificationMutation,
	UpdatePaymentVerificationMutationVariables,
} from "~/types/__generated/gql/graphql";
import { getFileByIdQueryKey } from "../useGetFileById";
import { useAppRouter } from "~/hooks/use-app-router";

const query = /* GraphQL */ `
	mutation UpdatePaymentVerification($input: UpdatePaymentVerificationInput!) {
		updatePaymentVerification(input: $input) {
			_id
		}
	}
`;

export type UpdatePaymentVerificationVariables =
	UpdatePaymentVerificationMutationVariables;
export type UpdatePaymentVerificationResults =
	UpdatePaymentVerificationMutation["updatePaymentVerification"];

export const useUpdatePaymentVerification = () => {
	const queryClient = useQueryClient();
	const { appQuery } = useAppRouter();

	return useMutation({
		mutationFn: (variables: UpdatePaymentVerificationVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.updatePaymentVerification),
		onSuccess: () => {
			void queryClient.invalidateQueries(getFileByIdQueryKey(appQuery.fileId!));
		},
	});
};
